import { atom } from 'recoil'
import partnerCookieEffect from './effects/cookieEffect'
import localStorageEffect from './effects/localStorageEffect'

export const partnerPicker = atom<
  | {
      partner_key: string
      partner_name: string
      partner_settings: Record<string, string | boolean>
    }
  | undefined
>({
  key: 'PartnerPicker',
  default: undefined,
  effects: [localStorageEffect('current_partner'), partnerCookieEffect()],
})
